import { Component, OnInit } from '@angular/core';
import { DocumentService } from '../document.service';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { RequestOfLeave } from '../objects/RequestOfLeave';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../core/auth.service';
import { UserService } from '../core/user.service';
import { Location } from '@angular/common';
import { AngularFireStorage } from '@angular/fire/storage';
import * as jsPDF from 'jspdf';
import { report } from '../../assets/requestPdf';
import { AngularFireDatabase } from '@angular/fire/database';

@Component({
  selector: 'app-open-requests',
  templateUrl: './open-requests.component.html',
  styleUrls: ['./open-requests.component.scss']
})
export class OpenRequestsComponent implements OnInit {
  firestoreConfig = {
    collection_endpoint: 'tasks'
  };
  requests: Observable<any[]>;
  minYear = new Date().getFullYear();
  isAdmin;

  constructor(private docService: DocumentService,
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    public authService: AuthService,
    public userService: UserService,
    private location: Location,
    private storage: AngularFireStorage,
    private realtimeDB: AngularFireDatabase
  ) { }

  ngOnInit() {
    this.checkAdmin();
    this.requests = this.afs.collection(this.firestoreConfig.collection_endpoint).snapshotChanges().pipe(
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as RequestOfLeave;
          data.id = a.payload.doc.id;
          console.log(data);
          return data;
        });
      }));
  }

  logout() {
    this.authService.doLogout()
      .then((res) => {
        this.location.back();
      }, (error) => {
        console.error(error);
      });
  }

  getDownloadURL(request) {
    this.storage.ref('uploads/' + request.requestId).getDownloadURL().subscribe((val) => {
      request.downloadURL = val;
      return val;
    });
  }

  convertDate(date) {
    const day = new Date(date.seconds * 1000).getDate();
    const month = new Date(date.seconds * 1000).getMonth() + 1;
    const year = new Date(date.seconds * 1000).getFullYear();
    return month + '/' + day + '/' + year;
  }

  checkAdmin() {
    var currentEmail = <String>this.afAuth.auth.currentUser.email;
    this.realtimeDB.list('admins/').valueChanges().subscribe(data => {
      Object.keys(data).forEach(user => {
        var incomingEmail = <String>data[user].email;
        if (incomingEmail.toUpperCase() === currentEmail.toUpperCase()) {
          this.isAdmin = true;
        }
      });
    }, (error) => {
      console.log(error);
      return false;
    }, () => {
      return false;
    });
    return false;
  }

  getCurrentUserUID() {
    return this.afAuth.auth.currentUser.uid;
  }

  approveRequest(request, approved) {
    if (confirm('Are you sure you want to approve this request?')) {
      this.createSignedRequestPDF(request, approved);
    }
  }

  denyRequest(request, approved) {
    if (confirm('Are you sure you want to deny this request?')) {
      this.createSignedRequestPDF(request, approved);
    }
  }

  createSignedRequestPDF(request, approved?) {
    let doc = new jsPDF();
    let img = report;
    doc.addImage(img, 'JPEG', 0, 0, 210, 290);

    let startDay = request.startDay;
    let startMonth = request.startMonth;
    let startTime = request.startTime;
    let endDay = request.endDay;
    let endMonth = request.endMonth;
    let endTime = request.endTime;

    let dateOfCreation = request.dateOfCreation;
    let timeOfCreation = request.timeOfCreation;
    let fromDate = request.fromDate;
    let toDate = request.toDate;
    const fullName = request.lastName + ', ' + request.firstName;
    let leaveRequested = request.leaveRequested;
    let leaveReason = request.leaveReason;
    let payroll = request.payrollNumber;
    let platoon = request.platoonNumber;
    let totalHours = request.totalNumberHours;
    let apparatus = request.apparatus;
    let exchangeWith = request.exchangeWithMember;
    doc.text(dateOfCreation, 34, 52);
    doc.text(platoon, 110, 52);
    doc.text(apparatus, 168, 52);
    doc.text(fullName, 53, 62);
    doc.text(payroll, 155, 62);

    switch (leaveRequested) {
      case 'compTime':
        doc.text('x', 83, 80);
        break;
      case 'Personal Leave currentYear':
        doc.text('x', 83, 92);
        break;
      case 'Personal Leave lastYear':
        doc.text('x', 83, 104);
        break;
      case 'Special Leave':
        doc.text('x', 83, 114);
        doc.text(leaveReason, 125, 114);
        break;
      case 'Exchange of Time':
        doc.text('x', 83, 128);
        break;
      case 'Union Business':
        doc.text('x', 83, 136);
        break;
      case 'School':
        doc.text('x', 83, 148);
        break;
    }

    // Set Personal Leave years
    doc.text(this.minYear.toString(), 131, 92);
    doc.text((this.minYear - 1).toString(), 131, 104);

    // Start Date
    doc.text(startMonth + '/' + startDay + '/' + request.fromYear.slice(-2), 37, 164);
    doc.text(startTime.toString(), 65, 164);
    // End Date
    doc.text(endMonth + '/' + endDay + '/' + request.toYear.slice(-2), 95, 164);
    doc.text(endTime.toString(), 124, 164);

    doc.text(totalHours.toString(), 180, 164);
    if (exchangeWith) {
      doc.text(exchangeWith.NAME, 75, 178);
      doc.text(exchangeWith.PAYROLL.toString(), 162, 178);
    }
    doc.text(fullName, 42, 204);
    doc.text(dateOfCreation, 128, 204);
    doc.text(timeOfCreation, 162, 204);

    // Sign and timestamp
    let currentDate = new Date();
    doc.text(this.afAuth.auth.currentUser.displayName, 60, 224);
    doc.text(currentDate.toLocaleDateString('en-US'), 130, 224);
    doc.text(this.afAuth.auth.currentUser.displayName, 54, 244);
    doc.text(currentDate.toLocaleDateString('en-US'), 134, 244);

    let blob = doc.output('dataurl');
    this.uploadDoc(blob, doc, request, approved); // NEED to get this downloadURL before we saveRequest
  }

  async uploadDoc(blob, doc, request, approved) {
    let path = '';
    if (approved) {
      path = `approvedRequests/${request.requestId}_approved.pdf`;
    } else {
      path = `deniedRequests/${request.requestId}_denied.pdf`;
    }
    const fileRef = this.storage.ref(path);
    let metadata = {
      contentType: 'application/pdf',
      email: this.afAuth.auth.currentUser.email,
    };

    await fileRef.putString(blob, 'data_url');
    fileRef.getDownloadURL().subscribe(url => {
      console.log(url);
      request.downloadURL = url;
      if (approved) {
        this.docService.approveRequest(request, request.id);
      } else {
        this.docService.denyRequest(request, request.id);
      }
    });
  }
}
